import { useState } from 'react';
import { Check, Copy, Braces } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';

/** Render valid, copyable JSON as text; never interpret source content as HTML. */
export function MemoryJson({ value, filename, compact = false }: { value: unknown; filename: string; compact?: boolean }) {
  const { t } = useI18n();
  const [copyState, setCopyState] = useState<'idle' | 'done' | 'failed'>('idle');
  const json = JSON.stringify(value, null, 2);
  const tokens = json.split(/("(?:\\.|[^"\\])*"\s*:|"(?:\\.|[^"\\])*"|\b(?:true|false|null)\b|\b\d+\b)/g);
  const copy = async () => {
    try { await navigator.clipboard.writeText(json); setCopyState('done'); }
    catch { setCopyState('failed'); }
  };
  return <div className={`lp-json ${compact ? 'lp-json-compact' : ''}`} data-filename={filename}>
    <div className="lp-json-toolbar"><span><Braces size={15} />{compact ? 'JSON' : t('记忆', 'Memory')}</span>{!compact && <button onClick={copy}>{copyState === 'done' ? <Check size={12} /> : <Copy size={12} />}{copyState === 'done' ? t('已复制', 'Copied') : t('复制 JSON', 'Copy JSON')}</button>}</div>
    <pre lang="zh-CN" tabIndex={compact ? undefined : 0} aria-label={t('记忆 JSON 原文', 'Original memory JSON')}><code>{tokens.map((token, index) => <span key={index} className={token.startsWith('"') ? (token.trimEnd().endsWith(':') ? 'lp-json-key' : 'lp-json-string') : /^(true|false|null|\d+)$/.test(token) ? 'lp-json-value' : undefined}>{token}</span>)}</code></pre>
    {copyState === 'failed' && <p role="status" className="lp-json-copy-error">{t('复制未完成，可以选中上方 JSON 手动复制。', 'Copy failed. Select the JSON above to copy it manually.')}</p>}
  </div>;
}
